<template>
  <div class="pct-w-100">
    <p v-if="!scenarios.length">No scenarios found</p>
    <div class="row flex-nowrap">
      <!--##################################################-->
      <!--region Scenarios-->
      <div class="col">
        <b-form-group v-if="!!scenarios.length">
          <template v-slot:label>
            <b>Select scenarios:</b><br>
          </template>
          <b-form-checkbox
            v-model="flagAllScenariosSelected"
            aria-describedby="scenarios"
            aria-controls="scenarios"
            @change="toggleAllScenarios"
          >
            {{ flagAllScenariosSelected ? 'Un-select All' : 'Select All' }}
          </b-form-checkbox>

          <div style=" max-height: 18vh; overflow-y: visible; overflow-x: hidden;">
            <b-form-checkbox-group
              id="scenarios"
              v-model="selectedScenarios"
              :options="optionsScenarios"
              name="scenarios"
              class="ml-4"
              aria-label="Scenarios"
              stacked
            />
          </div>
        </b-form-group>
      </div>
      <!--endregion Scenarios-->
      <!--##################################################-->
      <!--region Vectors-->
      <div class="col">
        <b-form-group v-if="!!vectors.length">
          <template v-slot:label>
            <b>Select Vectors:</b><br>
          </template>
          <b-form-checkbox
            v-model="flagAllVectorsSelected"
            aria-describedby="scenarios"
            aria-controls="scenarios"
            @change="toggleAllVectors"
          >
            {{ flagAllVectorsSelected ? 'Un-select All' : 'Select All' }}
          </b-form-checkbox>
          <div style=" max-height: 500px; overflow-y: visible; overflow-x: hidden;">
            <b-form-checkbox-group
              id="vectors"
              v-model="selectedVectors"
              :options="vectors"
              name="scenarios"
              class="ml-4"
              aria-label="Vectors"
              stacked
            />
          </div>
        </b-form-group>
      </div>
      <!--endregion Vectors-->
      <!--##################################################-->
      <b-col>
        <b-form-group id="amount-group">
          <template v-slot:label>
            <b>Months to Graph</b>
          </template>
          <b-form-input 
              type="number" 
              v-model.number="selectedAmount" 
              min="1" max="500" step="1">
          </b-form-input>
        </b-form-group>
        <button @click="runChart" class="btn btn-primary btn-lg">Show</button>
      </b-col>
      <!--##################################################-->
    </div>
    <!--##################################################-->
    <!--region Chart-->
    <div class="row">
      <div class="col-12">
        <graphLineChart
          :pDataSet="graphLineChartData"
          :switcherNewPropsHaveCome="switcherNewPropsHaveCome"
        ></graphLineChart>
      </div>
    </div>
    <!--endregion Chart-->
    <!--##################################################-->
  </div>
</template>

<script>

import ManagerRequest from "@/services/ManagerRequest";
import service        from "@/services/HttpRequestService";
import graphLineChart from '@/components/common/graphLineChart';

export default {
  name:  "ChartScenarios",
  props: {
    scenarios: {
      type:    Array,
      default: () => []
    }
  },
  data() {
    return {
      graphLineChartData:       [],
      switcherNewPropsHaveCome: true,
      // ##### Vectors related
      vectors:                [
        {text: "CPR", value: "Cpr"},
        {text: "CDR", value: "Cdr"},
        {text: "Loss Severity", value: "LossSeverity"},
        {text: "Delinquency", value: "Delinquency"}
      ],
      selectedVectors:        ["Cpr"],
      flagAllVectorsSelected: false,
      // ##### Scenarios related
      selectedScenarios:        [],
      flagAllScenariosSelected: false,
      // ##### Settings
      selectedAmount: 60
    }
  },
  created() {
    this.checkScenarios(3);
    this.runChart();
  },
  computed:   {
    optionsScenarios() {
      return (this.scenarios || [])
        .map(({
                Id:           value,
                ScenarioName: name,
                DealName:     dealName,
                Vendor:       vendor
              }) => {
          const vendorAndDeal     = [vendor, dealName].filter(Boolean);
          const vendorAndDealText = vendorAndDeal.length ? ` (${vendorAndDeal.join(', ')})` : '';
          const text              = `${name}${vendorAndDealText}`
          return {value, text};
        });
    }
  },
  methods:    {
    toggleAllScenarios(checked) {
      this.selectedScenarios = checked ? this.optionsScenarios.map(({value}) => value) : [];
    },
    toggleAllVectors(checked) {
      this.selectedVectors = checked ? this.vectors.map(({value}) => value) : [];
    },
    checkScenarios(amount = 3) {
      let arr                = this.optionsScenarios.slice(0, amount);
      this.selectedScenarios = arr.map(({value}) => value);
    },
    cancel() {
      this.$emit('cancel');
    },
    async runChart() {
      const selectedAmount    = this.selectedAmount;
      let finalAmount         = null;
      let arr                 = [];
      let graphLineChartData  = [];
      this.graphLineChartData = [];
      let objScenario         = null;
      try {
        for (const id of this.selectedScenarios) {
          objScenario   = await (new ManagerRequest(
            service.getUserScenarioById,
            service,
            null
          ))
            .do(id);
          let nameStart = `${objScenario.ScenarioName} (${objScenario.Vendor}, ${objScenario.DealName})`
          if (this.selectedVectors.includes('Cdr')) {
            arr         = objScenario.Cdr;
            finalAmount = selectedAmount ? selectedAmount : arr.length;
            graphLineChartData.push(
              [`${nameStart}:Cdr`].concat(arr.slice(0, finalAmount))
            );
          }
          if (this.selectedVectors.includes('Cpr')) {
            arr         = objScenario.Cpr;
            finalAmount = selectedAmount ? selectedAmount : arr.length;
            graphLineChartData.push(
              [`${nameStart}:Cpr`].concat(arr.slice(0, finalAmount))
            );
          }
          if (this.selectedVectors.includes('Delinquency')) {
            arr         = objScenario.Delinquency;
            finalAmount = selectedAmount ? selectedAmount : arr.length;
            graphLineChartData.push(
              [`${nameStart}:Delinquency`].concat(arr.slice(0, finalAmount))
            );
          }
          if (this.selectedVectors.includes('LossSeverity')) {
            arr         = objScenario.LossSeverity;
            finalAmount = selectedAmount ? selectedAmount : arr.length;
            graphLineChartData.push(
              [`${nameStart}:Loss Severity`].concat(arr.slice(0, finalAmount))
            );
          }
        }
        this.graphLineChartData       = graphLineChartData;
        this.switcherNewPropsHaveCome = !this.switcherNewPropsHaveCome;
      } catch (e) {
        // Do nothing
      }
    }
  },
  watch:      {
    selectedScenarios(newVal, oldVal) {
      this.flagAllScenariosSelected = newVal.length === this.optionsScenarios.length;
    },
    selectedVectors(newVal, oldVal) {
      this.flagAllVectorsSelected = newVal.length === this.vectors.length;
    }
  },
  components: {
    graphLineChart
  }
}
</script>
<style lang="scss" scoped>

</style>
